module.exports = __webpack_public_path__ + "cf15a64943f6c7d24a2b93629bd1def5.svg";